module.exports = __webpack_public_path__ + "static/img/icons2-02 1.d2b3e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons2-02 1.png
// module id = 0xWq
// module chunks = 1